import React, { PropsWithChildren, useEffect } from 'react';
import { DndProvider, useDragLayer } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';

const DisableUserSelection = ({ children }: PropsWithChildren<{}>) => {
  const { isDragging } = useDragLayer(monitor => ({
    isDragging: monitor.isDragging()
  }));

  useEffect(() => {
    if (isDragging) {
      document.documentElement.style.userSelect = 'none';
    } else {
      document.documentElement.style.userSelect = '';
    }
  }, [isDragging]);

  return <>{children}</>;
};

const DndContainer = ({ children }: PropsWithChildren<{}>) => (
  <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
    <DisableUserSelection>{children}</DisableUserSelection>
  </DndProvider>
);

export default DndContainer;
